import { i18n } from '../../i18n';
import { useLanguage } from './useLanguage';
import './language.css';

export interface LanguageSwitcherProps {
  readonly className?: string;
}

export function LanguageSwitcher({ className }: LanguageSwitcherProps) {
  const {
    language,
    isChangingLanguage,
    selectLanguage,
  } = useLanguage();
  const english = i18n.getFixedT('en');
  const arabic = i18n.getFixedT('ar');
  const classes = ['language-switcher', className].filter(Boolean).join(' ');

  return (
    <div className={classes} role="group" aria-label={i18n.t('language.switcherLabel')}>
      <button
        className="language-switcher__button"
        type="button"
        lang="en"
        dir="ltr"
        aria-pressed={language === 'en'}
        disabled={isChangingLanguage}
        onClick={() => void selectLanguage('en')}
      >
        {english('language.names.english')}
      </button>
      <button
        className="language-switcher__button"
        type="button"
        lang="ar"
        dir="rtl"
        aria-pressed={language === 'ar'}
        disabled={isChangingLanguage}
        onClick={() => void selectLanguage('ar')}
      >
        {arabic('language.names.arabic')}
      </button>
    </div>
  );
}
